import Form from 'vform'
import axios from 'axios'
Form.axios = axios
